"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyContent = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
require("./sticky-content.scss");
const StickyContent = (props) => {
    const { className, children } = props;
    const classNames = (0, classnames_1.default)('sticky-content', className !== null && className !== void 0 ? className : '');
    return (react_1.default.createElement("div", { className: classNames }, children));
};
exports.StickyContent = StickyContent;
//# sourceMappingURL=StickyContent.js.map